const ingredients = [
  "Knorr Chicken Powder",
  "Knorr Chattpatta Masala",
  "Knorr Tomato Ketchup",
  "Knorr Chilli Garlic Sauce",
  "Knorr Thai Sweet Chilli Sauce",
  "Knorr Pizza Pasta Sauce",
  "Knorr Green Chutney",
  "Knorr Barbecue Sauce",
  "Knorr Chicken Soup Stock",
  "Knorr Pulao Soup Stock",
  "Knorr Chattpatta Noodles",
  "Knorr Chicken Noodles",
  "Knorr Blazin Noodles",
  "Knorr Spicy Beef Noodles",
  "CHARCOAL (FOR SMOKE)",
  "CHARCOAL",
  "COCONUT",
  "CANOLA OIL",
  "RAFHAN CORN OIL",
  "FULL CREAM MILK",
  "BESAN (GRAM FLOUR)",
  "BESAN",
  "BEEF LEG",
  "BEEF SHOULDER",
  "BEEF, MINCED",
  "BEEF",
  "BONELESS BEEF",
  "BONELESS CHICKEN",
  "BONELESS CHICKEN (FILLET PIECES)",
  "BONELESS CHICKEN (THIGH PIECES)",
  "BONELESS MUTTON CUBES",
  "BRAIN",
  "BUFFALO",
  "CAMEL",
  "CHICKEN",
  "CHICKEN MINCED",
  "CHICKEN LEG",
  "CHICKEN THIGHS (DEBONED)",
  "CHICKEN WINGS",
  "CHICKERN BREAST",
  "COW",
  "COW LEG",
  "COW RIBS",
  "COW SHOULDER",
  "DASTI COW",
  "DASTI GOAT",
  "DASTI LAMB",
  "DASTI SHEEP",
  "FRONT LEG SHEEP",
  "FRONT LEG COW",
  "FRONT LEG GOAT",
  "FRONT LEG LAMB",
  "FULL BAKRA",
  "GOAT",
  "GOAT LEG",
  "GOAT RIBS",
  "GOAT SHOULDER",
  "KALEJI",
  "LAMB",
  "LAMB LEG",
  "LAMB RIBS",
  "LAMB SHOULDER",
  "LEG ROAST",
  "MUTTON LEG",
  "PRAWN",
  "RAAN",
  "SHEEP",
  "SHEEP RIBS",
  "SHRIMPS",
  "WHOLE CHICKEN",
  "MILK",
  "CASHEW NUTS",
  "WOODEN SKEWERS",
  "METAL SKEWERS",
  "AJWAIN (CAROM SEEDS) POWDER",
  "AJWAIN",
  "ALLSPICE",
  "ANISEED",
  "BEHARI MASALA",
  "BEHARI KABAB",
  "BLACK CUMIN",
  "BLACK PEPPER",
  "BLACK PEPPER (CRUSHED)",
  "BLACK PEPPER POWDER",
  "BROWN CARDAMOM",
  "CARDAMOM POWDER",
  "CAROM",
  "CHAAT MASALA",
  "CHICKEN TIKKA",
  "CHICKEN POWDER",
  "CHILLI POWDER",
  "CINNAMON",
  "CITRIC ACID",
  "CLOVES",
  "CORIANDER",
  "CORIANDER POWDER",
  "CORIANDER SEEDS",
  "CORNFLOUR",
  "CREAM",
  "CRUSHED CORIANDER",
  "CRUSHED CUMIN",
  "CUMIN",
  "CUMIN POWDER",
  "CUMIN SEEDS",
  "DILL SEED",
  "DRIED PAPAYA POWDER",
  "FENNEL SEEDS (SAUNF)",
  "FENNEL SEEDS",
  "FENUGREEK SEEDS",
  "GARAM MASALA",
  "GARAM MASALA POWDER",
  "GARLIC PASTE",
  "GINGER",
  "GINGER GARLIC PASTE",
  "GINGER PASTE",
  "GREEN CARDAMOM",
  "GREEN CHILLI PASTE",
  "HIMALAYAN PINK SALT",
  "KALONJI (NIGELLA SEEDS)",
  "KALONJI",
  "KARAHI MASALA",
  "KASHMIRI RED CHILLI POWDER",
  "KASURI METHI (DRIED FENUGREEK LEAVES)",
  "KASURI METHI",
  "LONG PEPPER",
  "MALTODEXTRIN",
  "MEAT TENDERIZER",
  "MUSTARD POWDER",
  "MUSTARD SEEDS",
  "NUTMEG POWDER",
  "PAPAYA PASTE (RAW)",
  "PAPAYA PASTE",
  "PAPRIKA",
  "RAW PAPAYA PASTE",
  "RED CHILI",
  "RED CHILI FLAKES",
  "RED CHILI POWDER",
  "RED CHILLI (CRUSHED)",
  "RED CHILLI POWDER",
  "ROASTED CHICKPEA",
  "SALT",
  "SEEKH KABAB",
  "SODIUM PHOSPHATE",
  "STAR ANISEED",
  "SUGAR",
  "TANDOORI MASALA",
  "TIKKA SEEKH KABAB",
  "TIKKA BOTI",
  "TURMERIC",
  "TURMERIC POWDER",
  "WHITE PEPPER",
  "WHITE PEPPER POWDER",
  "WHITE SESAME SEEDS",
  "COAL",
  "KARAHI",
  "KOYLA",
  "SEEKH",
  "SKEWERS",
  "WOK",
  "BAY LEAF",
  "BAY LEAVES",
  "BLACK CARDAMOM",
  "BLACK PEPPERCORNS",
  "CAPSICUM (CUT INTO CUBES)",
  "CLOVE",
  "DRIED MINT LEAVES",
  "DRIED PLUMS",
  "FRESH CORIANDER",
  "FRESH CORIANDER (CHOPPED)",
  "FRESH GREEN CHILLIES",
  "FRESH TOMATOES (CHOPPED)",
  "TOMATO (CHOPPED)",
  "GARLIC",
  "GARLIC (FINELY CHOPPED)",
  "GARLIC CLOVES",
  "GINGER (FINELY CHOPPED)",
  "GREEN CHILLIES",
  "GREEN CHILLIES (FINELY CHOPPED)",
  "LEMON JUICE",
  "LEMON SLICES / WEDGES",
  "MUSKMELON",
  "ONION (CUT INTO CUBES)",
  "ONION (FRESH)",
  "ONION (GRATED)",
  "ONION RINGS",
  "ONION",
  "POTATOES",
  "POTATO",
  "WATER",
  "YOGURT",
  "TIKKA BOTI RECIPE MIX",
  "SEEKH KABAB RECIPE MIX",
  "CHICKEN TANDOORI RECIPE MIX",
  "CHICKEN TIKKA RECIPE MIX",
  "BIHARI KABAB RECIPE MIX",
  "MALAI BOTI RECIPE MIX",
  "CHAPLI KEBAB RECIPE MIX",
  "FRIED CHOPS RECIPE MIX",
  "COOKING OIL",
  "LEMON",
  "LEMON SLICES",
  "ALMOND",
  "ANCHOVY",
  "ARTICHOKE",
  "ASIAN COLESLAW",
  "ASPARAGUS",
  "AUBERGINE",
  "AVOCADO",
  "BABY CORN",
  "BABY GEM LETTUCE",
  "BABY POTATO",
  "BABY SPINACH",
  "BAGEL",
  "BAKING POWDER",
  "BAKING SODA",
  "BALSAMIC VINEGAR",
  "BARBECUE SAUCE",
  "BARLEY",
  "BASIL",
  "BASMATI RICE",
  "BEANS",
  "BEANSPROUTS",
  "BEEF LOIN",
  "BEEF MINCE",
  "BEEF STEAK",
  "BEEF TENDERLOIN",
  "BEET",
  "BEETROOT",
  "BELL PEPPER",
  "BITTER GOURD",
  "BLACK BEAN",
  "BLACK SALT",
  "BLAZIN NOODLES",
  "BOK CHOY",
  "BOTTLE GOURD",
  "BREAD",
  "BREAD CRUMB",
  "BREADCRUMBS",
  "BRIE CHEESE",
  "BROCCOLI",
  "BRUSSELS SPROUT",
  "BUN",
  "BURGER BUN",
  "BUTTER",
  "BUTTERMILK",
  "BUTTON MUSHROOM",
  "CABBAGE",
  "CAESAR SALAD DRESSING",
  "CANNED BAKED BEANS",
  "CARDAMOM",
  "CARROT",
  "CASHEW",
  "CAULIFLOWER",
  "CELERY",
  "CHATTPATTA MASALA",
  "CHATTPATTA NOODLES",
  "CHEDDAR CHEESE",
  "CHEESE",
  "CHEESE POWDER",
  "CHEESE SLICE",
  "CHERRY TOMATOES",
  "CHESTNUT",
  "CHICKEN BREAST",
  "CHICKEN BROTH",
  "CHICKEN DRUMSTICK",
  "CHICKEN MINCE",
  "CHICKEN NOODLES",
  "CHICKEN SOUP STOCK",
  "CHICKEN TENDERS",
  "CHICKEN THIGH",
  "CHICKEN WING",
  "CHICKPEA FLOUR",
  "CHICKPEAS",
  "CHILLI",
  "CHILLI GARLIC SAUCE",
  "CHILLI SAUCE",
  "CIABATTA",
  "CILANTRO",
  "CINNAMON STICKS",
  "COCONUT MILK",
  "COD",
  "COLESLAW",
  "CORN",
  "CORN FLOUR",
  "CORN OIL",
  "CORN TORTILLAS",
  "CORN TOSTADA",
  "CORNFLAKES",
  "CORNSTARCH",
  "CORNSTRACH",
  "COTTAGE CHEESE",
  "COURGETTE",
  "CRAB",
  "CRABMEAT",
  "CREAM CHEESE",
  "CROISSANT",
  "CROUTONS",
  "CRUSHED CHILLI",
  "CRUSHED PICKLES",
  "CUCUMBER",
  "CURRY LEAF",
  "DATES",
  "DIJON MUSTARD",
  "DILL",
  "DOUGH",
  "DRIED CORIANDER",
  "DRIED FENUFREEK LEAVES",
  "DRIED PLUM",
  "DRIED POMEGRANATE SEEDS",
  "EDAMAME BEANS",
  "EGG",
  "EGGPLANT",
  "FENNEL",
  "FENUGREEK",
  "FENUGREEK LEAVES",
  "FETA CHEESE",
  "FETTUCCINE",
  "FILO PASTRY",
  "FISH",
  "FLOUR",
  "FOCACCIA",
  "FRIED ONIONS",
  "GEM LETTUCE",
  "GHEE",
  "GHERKIN",
  "GREEN BEANS",
  "GREEN CHILLI",
  "GREEN CHUTNEY",
  "GREEN PEAS",
  "GREEN PEPPER",
  "HABANERO",
  "HALIBUT",
  "HERRING",
  "HOT SAUCE",
  "HOTDOG",
  "ITALIAN HERBS",
  "JAGGERY",
  "JALAPENO",
  "JALAPENO PEPPER",
  "KALE",
  "KASHMIRI CHILLI",
  "KIDNEY BEANS",
  "KIMCHI",
  "KING PRAWN",
  "LEEKS",
  "LEMON GRASS",
  "LEMON WEDGES",
  "LENTILS",
  "LETTUCE",
  "LIME",
  "LOAF",
  "LUNCHEON MEAT",
  "MACARONI",
  "MACE",
  "MACKEREL",
  "MAHI MAHI",
  "MAILLE MUSTARD",
  "MANGO PICKLES",
  "MAYONNAISE",
  "MEATBALL",
  "MINCED MEAT",
  "MINT",
  "MIXED PICKLES",
  "MOZZARELLA CHEESE",
  "MUSHROOM",
  "MUSTARD",
  "MUTTON",
  "MUTTON MINCE",
  "NAPA CABBAGE",
  "NOODLES",
  "NUTMEG",
  "NUTS",
  "OATMEAL",
  "OATS",
  "OIL",
  "OKRA",
  "OLIVES",
  "ORANGE",
  "OREGANO",
  "PANEER",
  "PAPAYA",
  "PARATHA",
  "PARMESAN CHEESE",
  "PARMESAN CHEESE POWDER",
  "PARSLEY",
  "PARSNIP",
  "PASTA",
  "PASTRY",
  "PEANUT",
  "PEANUT BUTTER",
  "PEAS",
  "PEPPER",
  "PEPPERCORN",
  "PEPPERONI",
  "PEPPERS",
  "PICKLE",
  "PICKLED CUCUMBER",
  "PINK HIMALAYAN SALT",
  "PINK SALT",
  "PISTACHIO",
  "PITAS",
  "PIZZA DOUGH",
  "PIZZA PASTA SAUCE",
  "PIZZA SAUCE",
  "PLUM",
  "POMEGRANATE",
  "POMEGRANATE MOLASSES",
  "POULTRY",
  "PULAO SOUP STOCK",
  "QUINOA",
  "RADISH",
  "RAPESEED OIL",
  "RASPBERRY",
  "RED BELL PEPPER",
  "RED CABBAGE",
  "RED CHILLI",
  "RED CURRY PASTE",
  "RED KIDNEY BEANS",
  "RED ONION",
  "RED PEPPER",
  "RICE",
  "RICOTTA CHEESE",
  "ROSEMARY",
  "RUSSET POTATO",
  "SAFFRON",
  "SALAD DRESSING",
  "SALAD LEAF",
  "SALMON",
  "SALMON FILLET",
  "SALSA",
  "SAMOSA PATTI",
  "SAUSAGE",
  "SHALLOT",
  "SHELL PASTA",
  "SHREDDED CHEESE",
  "SHRIMP",
  "SOUR CREAM",
  "SOY SAUCE",
  "SOYBEAN",
  "SPAGHETTI",
  "SPICY BEEF NOODLES",
  "SPINACH",
  "SPRING ONION",
  "STARANISE",
  "SUMAC",
  "SUNFLOWER OIL",
  "SWEET CORN",
  "SWEET POTATO",
  "SWEET THAI CHILLI SAUCE",
  "TAHINI",
  "TAJIN",
  "TAMARIND",
  "THAI BASIL",
  "THYME",
  "TOMATO",
  "TOMATO KETCHUP",
  "TOMATO PASTE",
  "TOMATO PUREE",
  "TOMATO SAUCE",
  "TORTILLAS",
  "TUNA",
  "TURKEY",
  "TURKEY BACON",
  "TURKEY BREAST",
  "TURKEY CUTLETS",
  "TURKEY WRAPS",
  "TURNIP",
  "VEGETABLE OIL",
  "VINEGAR",
  "WALNUTS",
  "WASABI",
  "WHEAT",
  "WHEAT FLOUR",
  "WHITE BEAN",
  "WHITE BREAD",
  "WHITE ONION",
  "WHOLE RED CHILLI",
  "WHOLE WHEAT BREAD",
  "YELLOW BELL PEPPER",
  "YELLOW ONION",
  "ZUCCHINI",
  "THAI SWEET CHILLI SAUCE",
  "BLAZIN' HOT NOODLES"
];

export default ingredients;
